import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=6c5ada4b&scoped=true&"
import script from "./OrderListItem.vue?vue&type=script&lang=js&"
export * from "./OrderListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=6c5ada4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ada4b",
  null
  
)

component.options.__file = "OrderListItem.vue"
export default component.exports